@if (open) {
    <div class="nw-filters-drawer__backdrop" (click)="onClose()" aria-hidden="true"></div>

    <aside
        class="nw-filters-drawer"
        role="dialog"
        aria-modal="true"
        tabindex="0"
        (keydown.escape)="onClose()"
        [attr.aria-label]="title"
    >
        <div class="nw-filters-drawer__header">
            <h2 class="nw-filters-drawer__title">{{ title }}</h2>

            <button
                type="button"
                class="nw-filters-drawer__close"
                (click)="onClose()"
                aria-label="Close filters"
            >
                ✕
            </button>
        </div>

        <div class="nw-filters-drawer__content">
            @for (section of sections; track trackBySection(section)) {
                <section class="nw-filters-drawer__section" data-test="filters-section">
                    <button
                        type="button"
                        class="nw-filters-drawer__section-toggle"
                        (click)="toggleSection(section.id)"
                        [attr.aria-expanded]="isSectionExpanded(section.id)"
                    >
                        <span>{{ section.title }}</span>
                        <span
                            class="nw-filters-drawer__chevron"
                            [class.nw-filters-drawer__chevron--expanded]="
                                isSectionExpanded(section.id)
                            "
                            aria-hidden="true"
                        >
                            <nw-icon icon="chevron-up"></nw-icon>
                        </span>
                    </button>

                    @if (isSectionExpanded(section.id)) {
                        <div class="nw-filters-drawer__options">
                            @for (
                                option of section.options;
                                track trackByOption(option)
                            ) {
                                <label class="nw-filters-drawer__option">
                                    <input
                                        class="nw-filters-drawer__input"
                                        [type]="section.type"
                                        [name]="section.id"
                                        [checked]="isSelected(section.id, option.value)"
                                        (change)="
                                            section.type === 'checkbox'
                                                ? onCheckboxChange(
                                                      section.id,
                                                      option.value,
                                                      $any($event.target).checked
                                                  )
                                                : onRadioChange(section.id, option.value)
                                        "
                                    />
                                    <span class="nw-filters-drawer__label">
                                        {{ option.label }}
                                    </span>
                                </label>
                            }
                        </div>
                    }
                </section>
            }
        </div>

        <div class="nw-filters-drawer__footer">
            <button
                nw-outline-button
                type="button"
                color="primary"
                [disabled]="!hasSelectedFilters"
                (click)="onClear()"
            >
                Clear filters
            </button>

            <button
                nw-button
                type="button"
                [disabled]="!hasChanges"
                color="primary"
                (click)="onApply()"
            >
                Apply filters
            </button>
        </div>
    </aside>
}
